import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
  background-color: ${({ theme }) => theme.palette.primary.background};
  display: grid;
  grid-template-columns: 1fr 1fr 8px;
  gap: 20px;
  padding: 15px 0;
  margin: 0 15px;

  &:last-child {
    border-bottom: none;
  }
`;

export const Column = styled.div`
  display: grid;
  gap: 5px;
`;

export const Number = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const Price = styled(Typography.Title)`
  text-align: right;
`;

export const Date = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
  text-align: right;
`;
